import { useCallback } from 'react'
import { useSlsDispatchContext } from '@fs/zion-sls'
import { useR2DispatchContext } from '../../../providers/r2Provider/R2Context'
import { useSharedBrowserStateContext } from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

export default function useSetReferenceFocusedIndex() {
  const r2Dispatch = useR2DispatchContext()
  const sharedBrowserState = useSharedBrowserStateContext()
  const slsDispatch = useSlsDispatchContext()

  return useCallback(
    (value) => {
      r2Dispatch({ type: 'SET_REFERENCE_FOCUSED_INDEX', value })
      const newReferenceArk = sharedBrowserState.thumbnails?.[value]?.ark
      if (newReferenceArk) {
        slsDispatch({ type: 'ADD_ARKS_TO_LOAD', value: [newReferenceArk] })
      }
    },
    [r2Dispatch, slsDispatch, sharedBrowserState.thumbnails]
  )
}
